var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userData.name!=='')?_c('span',{attrs:{"title":_vm.userData.username + " (" + _vm.userData.id + ")"}},[_vm._v(_vm._s(_vm.userData.firstName)+" "+_vm._s(_vm.userData.lastName))]):_c('span',[_vm._v("Please Sign In")])])}
var staticRenderFns = []

export { render, staticRenderFns }